import { render, staticRenderFns } from "./StartView.vue?vue&type=template&id=1c376490&scoped=true"
import script from "./StartView.vue?vue&type=script&lang=js"
export * from "./StartView.vue?vue&type=script&lang=js"
import style0 from "./StartView.vue?vue&type=style&index=0&id=1c376490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c376490",
  null
  
)

export default component.exports